import React from 'react';


import { ajax, loadMarketPlaceConfs, loadMarketPlaceSet, downloadFile } from '../components/globals';

import { Languages } from '../components/languages';

import { ConfiguratedList, LogoList, ModalBoxFluid, UCheckbox, UInput, USearch, UButton } from '../components/utilities';
import { PageTitle, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox } from '../components/guiElements';
import { EbayConnector } from '../components/ebayConnector';


//import { MarketplaceModalDetails } from '../components/marketplaceModals';


export default class Marketplaces extends React.Component {
    //#region CTOR and Events
    //#region CTOR
    constructor(props) {
        super(props);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.Marketplaces[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.state = {
            modalTarget: null,
            logoName: '',
            details: this.buildDetails(),
            allDetails: {},
            marketPlaceListConf: [],
            filter: ''
            
        };
        this.logoClick = this.logoClick.bind(this);
        this.detailsChange = this.detailsChange.bind(this);
        this.listButtonClick = this.listButtonClick.bind(this);
        this.filterChange = this.filterChange.bind(this);
    }
    //#endregion CTOR

    //#region data functions

    buildDetails() {
        return {
            id: null,
            name:'',
            marketplace: '',
            status: false,
            chkAutomaticUpdate:false,
        };
    }

    filterChange(ev) {
        this.setState({ filter: ev.target.value });
    }

    buildMarketPlaceDetail(name)
    {
      
        switch (name.toLowerCase()) {
            case "amazon":
                return this.buildAmazon();
            case "woocommerce":
                return this.buildWooCommerce();
            case "prestashop":
                return this.buildPrestaShop();
            case "magento1":
                return this.buildMagento1();
            case "magento2":
                return this.buildMagento2();
            case "shopify":
                return this.buildShopify();
            case "ebay":
                return this.buildEbay();
            default:
                return this.buildDetails();
        }
        
    }
    buildAmazon() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            sellerNo: '',
            token: '',
            region: '',
            chkBusinessOrders: false,
            chkPremiumOrders: false,
            chkPrimeOrders: false,
            chkLastDeliveryDate: false,
        };

        return detail;    
    }
    buildWooCommerce() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            wooUrl: '',
            consumerKey: '',
            consumerSecret: ''
            
        };
        return detail;
    }

    buildEbay() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            url: 'https://api.ebay.com',
            clientId: 'Supernov-Sendabox-PRD-e16c2648a-fbaa3887',
            clientSecret: 'PRD-16c2648aad04-cad9-400d-8cf8-6bef',
            redirectUrl: 'Supernova_s.r.l-Supernov-Sendab-ywjcycyj',
            scope: "https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/buy.order.readonly https://api.ebay.com/oauth/api_scope/buy.guest.order https://api.ebay.com/oauth/api_scope/sell.marketing.readonly https://api.ebay.com/oauth/api_scope/sell.marketing https://api.ebay.com/oauth/api_scope/sell.inventory.readonly https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.account.readonly https://api.ebay.com/oauth/api_scope/sell.account https://api.ebay.com/oauth/api_scope/sell.fulfillment.readonly https://api.ebay.com/oauth/api_scope/sell.fulfillment https://api.ebay.com/oauth/api_scope/sell.analytics.readonly https://api.ebay.com/oauth/api_scope/sell.marketplace.insights.readonly https://api.ebay.com/oauth/api_scope/commerce.catalog.readonly https://api.ebay.com/oauth/api_scope/buy.shopping.cart https://api.ebay.com/oauth/api_scope/buy.offer.auction https://api.ebay.com/oauth/api_scope/commerce.identity.readonly https://api.ebay.com/oauth/api_scope/commerce.identity.email.readonly https://api.ebay.com/oauth/api_scope/commerce.identity.phone.readonly https://api.ebay.com/oauth/api_scope/commerce.identity.address.readonly https://api.ebay.com/oauth/api_scope/commerce.identity.name.readonly https://api.ebay.com/oauth/api_scope/commerce.identity.status.readonly https://api.ebay.com/oauth/api_scope/sell.finances https://api.ebay.com/oauth/api_scope/sell.item.draft https://api.ebay.com/oauth/api_scope/sell.payment.dispute https://api.ebay.com/oauth/api_scope/sell.item https://api.ebay.com/oauth/api_scope/sell.reputation https://api.ebay.com/oauth/api_scope/sell.reputation.readonly"
        };
        return detail;
    }

    buildPrestaShop() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            prestaUrl: '',
            apiKey: '',
           idshop:'',
            paymentStateId:''
        };

        return detail;
    }

    buildMagento1() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            magentoUrl: '',
            consumerKey: '',
            consumerSecret: '',
            username: '',
            password: ''
        };

        return detail;
    }

    buildMagento2() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            magentoUrl: '',
            username: '',
            password: ''
        };

        return detail;
    }

    buildShopify() {
        let detail = this.buildDetails();
        detail.marketPlacePars = {
            shopifyUrl: '',
            accessToken: ''
        };

        return detail;
    }

    searchMarketPlaceConf(listOfMarketPlaceConf,marketPlaceId)
    {
        let mPlaceConf = listOfMarketPlaceConf.find((el) => (el.id == marketPlaceId));

        return mPlaceConf;
    }

    loadMarketPlaceSet(listOfMarketPlaceConf, ok,ko)
    {
        loadMarketPlaceSet(this.uc.jwtToken,
            listOfMarketPlace => {
                let allDetails = {};
                for (let i = 0; i < listOfMarketPlace.length; i++) {
                    let marketPlace = listOfMarketPlace[i];
                    let mPlaceConf = this.searchMarketPlaceConf(listOfMarketPlaceConf, marketPlace.marketplace);
                    if (mPlaceConf == null)
                        continue;
                    allDetails[mPlaceConf.name] = Object.assign({ name: mPlaceConf.name, icon: mPlaceConf.logo, flag: marketPlace.status }, marketPlace);
                }
                this.setState({ allDetails: allDetails });
                ok(listOfMarketPlace);
            },
            ko => { ko(); },
            this
        );
    }

    deleteMarketPlace(name)
    {
        let newDetails = this.state.allDetails;
        let detail = newDetails[name];
        ajax(this, { method: 'post', url: '/api/marketplace/marketplace-set-delete/' + detail.id, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                delete newDetails[name];
                this.setState({ allDetails: newDetails });
            },
            error => {
                // to do message
            }
        );

    }

    connectMarketPlace(detail,ok,err)
    {

        ajax(this, { method: 'post', url: '/api/marketplace/marketplace-set', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: detail  },
            response => {
               
                ok(response.data.result.id);
                
            },
            error => { err.call(this, error); }
        );

    }

     //#endregion data functions

    //#region Events

    componentDidMount() {

        loadMarketPlaceConfs(this.uc.jwtToken,
            listOfMarketPlaces => {

                this.setState({ marketPlaceListConf: listOfMarketPlaces});

                this.loadMarketPlaceSet(listOfMarketPlaces,
                    okresp => { },
                    error => { });
            },
            ko => { },
            this
        );
    }

    logoClick(ev, name, marketPlaceId) {

        let details = this.buildMarketPlaceDetail(name);

        if (name in this.state.allDetails) {
            this.state.allDetails[name].marketPlacePars = Object.assign(details.marketPlacePars, this.state.allDetails[name].marketPlacePars);
            details = Object.assign(details, this.state.allDetails[name]);
        }

        if (marketPlaceId != null) {
            details.marketplace = marketPlaceId;
            details.name = name;
        }

        this.setState({ logoName: name, modalTarget: name, details: details });
    }

    detailsChange(ev/*, name, val*/) {
        //console.debug(`name: ${name}, val: ${val}`);
        //let details = JSON.parse(JSON.stringify(this.state.details));
        let name = ev.target.name;
        let val = (ev.target.type == 'checkbox' || ev.target.type == 'radio') ? ev.target.checked : ev.target.value;
        let details = this.state.details;
        if (name in details)
            details.name = val;
        else
            details.marketPlacePars[name] = val;
        this.setState({ details: details });
    }

    ebayDetailClick(token) {
        if (this.state.modalTarget.toLowerCase() == 'ebay') {
            if (token == null) {
                this.setState({ ebayConnector: true });
            }
            else if (token == "") {
                this.setState({ ebayConnector: false });
            }
            else {
                this.setState({ ebayConnector: false });
                let details = this.state.details;
                details.marketPlacePars['token'] = token;
                this.setState({ details: details }, () => { this.detailClick(null, true) });

            }
        }
    }

    detailClick(ev, response) {
        try {
            if (response) {
                let newDetails = this.state.allDetails;

                this.state.details.status = true;

                this.props.loaderShow();
                this.connectMarketPlace(this.state.details,
                    ok => {
                        this.props.loaderHide();
                        this.state.details.id = ok;
                        const marketplaceLogo = this.state.marketPlaceListConf.find((el) => (el.name == this.state.details.name));
                        newDetails[marketplaceLogo.name] = Object.assign({ icon: marketplaceLogo.logo, flag: this.state.details.status }, this.state.details);
                        this.setState({ allDetails: newDetails });
                        this.setState({ logoName: '', modalTarget: null });
                    },
                    error => {

                        this.props.loaderHide();
                        const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                        /*
                        let obj = {
                            title: msg.title,
                            width: "35%",
                            icon: "error",
                            messages: error != undefined && error != null && error.hasOwnProperty("errorMessage")
                            ? [error.errorMessage] : msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                        };
                        this.props.popUp(obj);*/
                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage")
                            ? [error.errorMessage] : msg.messages;
                        this.props.popupErrorMessage(messages);

                    }
                );
            }
            else
                this.setState({ logoName: '', modalTarget: null });
        }
        catch (e) {
            this.props.loaderHide();
            const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
            /*let obj = {
                title: msg.title,
                width: "35%",
                icon: "error",
                messages:msg.messages,
                buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
            };
            this.props.popUp(obj);*/
            
            this.props.popupErrorMessage(msg.messages);
        }
    }

    listButtonClick(ev, name, type, source) {
        //let newDetails = JSON.parse(JSON.stringify(this.state.allDetails));
        let newDetails = this.state.allDetails;
        var me = this;
        if (type === 'remove') {

            this.setState({
                messageBox: <UIMessageBox type="question" title={this.le.list.deleteTitle} message={this.le.list.deleteMessage}>
                    <UIButton className="" text={this.le.list.cancel} onClick={(ev) => this.setState({ messageBox: null })} />
                    <UIButton className="confirm" text={this.le.list.confirm} onClick={(ev) => { this.setState({ messageBox: null }); this.deleteMarketPlace(source) }} />
                </UIMessageBox>
            });

            //delete newDetails[source];
            //this.setState({ allDetails: newDetails });
        }
        else if (type === 'disable') {
            if (source in newDetails) {
                let newDet = newDetails[source];
                newDet.status = !newDet.status;
                this.props.loaderShow(0);
                this.connectMarketPlace(newDet,

                    ok => {
                        this.props.loaderHide();               
                        newDet.flag = newDet.status;
                        me.setState({ allDetails: newDetails });
                    },
                    err => {
                        this.props.loaderHide();
                        newDet.status = !newDet.status;
                        this.props.popupErrorMessage('');
                    });
            }
        }
        else if (type === 'edit') {
            newDetails[source].status = true;
            /*delete newDetails[source].icon;*/
            delete newDetails[source].flag;
            this.setState({ logoName: source, modalTarget: source, details: newDetails[source] });
        }
        else alert(`name: ${name}, type: ${type}, source: ${source}`);
    }

    helpClick(ev, marketplaceName) {
        let id = "";
        switch (marketplaceName.toLowerCase()) {
            case "amazon":
                //id = "Amazon";
                break;
            case "woocommerce":
                id = "WooCommerce";
                break;
            case "prestashop":
                id = "Prestashop";
                break;
            case "magento1":
                //id = "Magento-1";
                break;
            case "magento2":
                id = "Magento-2";
                break;
            case "shopify":
                id = "Shopify";
                break;
            case "ebay":
                id = "Ebay";
                break;
            default:
                break;
        }

        if (ev == null) {
            // only checking..
            return id.length > 0;
        }
        else {
            // downloading...
            if (id)
                downloadFile('api/filemanager/file/' + id, this.uc.jwtToken, error => { }, this);
        }
    }

    //#endregion Events
    //#endregion CTOR and Events



    buildAmazonGUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            <UIInput name="sellerNo" value={dVal.marketPlacePars.sellerNo} label={le.sellerNo} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="token" value={dVal.marketPlacePars.token} label={le.token} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="region" value={dVal.marketPlacePars.region} label={le.region} onChange={this.detailsChange} maxLength="1000" />
            {/*<UICheckbox name="chkBusinessOrders" value={dVal.marketPlacePars.chkBusinessOrders} label={le.chkBusinessOrders} onChange={this.detailsChange} />
            <UICheckbox name="chkPremiumOrders" value={dVal.marketPlacePars.chkPremiumOrders} label={le.chkPremiumOrders} onChange={this.detailsChange} />
            <UICheckbox name="chkPrimeOrders" value={dVal.marketPlacePars.chkPrimeOrders} label={le.chkPrimeOrders} onChange={this.detailsChange} />
            <UICheckbox name="chkLastDeliveryDate" value={dVal.marketPlacePars.chkLastDeliveryDate} label={le.chkLastDeliveryDate} onChange={this.detailsChange} />
            <UICheckbox name="chkAutomaticUpdate" value={dVal.chkAutomaticUpdate} label={le.chkAutomaticUpdate} onChange={this.detailsChange} />*/}
        </div>;
        return modal;
    }

    buildWooCommerceGUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            <UIInput name="wooUrl" value={dVal.marketPlacePars.wooUrl} label={le.wooUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerKey" value={dVal.marketPlacePars.consumerKey} label={le.consumerKey} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerSecret" value={dVal.marketPlacePars.consumerSecret} label={le.consumerSecret} onChange={this.detailsChange} maxLength="1000" />
        </div>;
        return modal;
    }
    buildPrestashopGUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            <UIInput name="prestaUrl" value={dVal.marketPlacePars.prestaUrl} label={le.prestaUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="apiKey" value={dVal.marketPlacePars.apiKey} label={le.apiKey} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="idshop" value={dVal.marketPlacePars.idshop} label={le.idshop} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="paymentStateId" value={dVal.marketPlacePars.paymentStateId} label={le.paymentStateId} onChange={this.detailsChange} maxLength="1000" />
        </div>;
        return modal;
    }
    buildMagento1GUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            <UIInput name="magentoUrl" value={dVal.marketPlacePars.magentoUrl} label={le.magentoUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerKey" value={dVal.marketPlacePars.consumerKey} label={le.consumerKey} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerSecret" value={dVal.marketPlacePars.consumerSecret} label={le.consumerSecret} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="username" value={dVal.marketPlacePars.username} label={le.username} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="password" value={dVal.marketPlacePars.password} label={le.password} onChange={this.detailsChange} maxLength="1000" />
        </div>;
        return modal;
    }
    buildMagento2GUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            <UIInput name="magentoUrl" value={dVal.marketPlacePars.magentoUrl} label={le.magentoUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerKey" value={dVal.marketPlacePars.consumerKey} label={le.consumerKey} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="consumerSecret" value={dVal.marketPlacePars.consumerSecret} label={le.consumerSecret} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="accessToken" value={dVal.marketPlacePars.accessToken} label={le.accessToken} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="accessTokenSecret" value={dVal.marketPlacePars.accessTokenSecret} label={le.accessTokenSecret} onChange={this.detailsChange} maxLength="1000" />
        </div>;
        return modal;
    }
    buildShopifyGUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            {/*<UInput name="shopifyUrl" rowClass="u-lift" value={dVal.marketPlacePars.shopifyUrl} pholder={le.shopifyUrl} onChange={this.detailsChange} />*/}
            <UIInput name="shopifyUrl" value={dVal.marketPlacePars.shopifyUrl} label={le.shopifyUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="accessToken" value={dVal.marketPlacePars.accessToken} label={le.accessToken} onChange={this.detailsChange} maxLength="1000" />
        </div>;
        return modal;
    } 
    buildEbayGUI(dVal, le) {
        let modal = <div id="marketplace-detail">
            {/*<UIInput name="ebayUrl" value={dVal.marketPlacePars.ebayUrl} label={le.ebayUrl} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="clientId" value={dVal.marketPlacePars.clientId} label={le.clientId} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="clientSecret" value={dVal.marketPlacePars.clientSecret} label={le.clientSecret} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="redirectUri" value={dVal.marketPlacePars.redirectUri} label={le.redirectUri} onChange={this.detailsChange} maxLength="1000" />
            <UIInput name="scope" value={dVal.marketPlacePars.scope} label={le.scope} onChange={this.detailsChange} maxLength="1000" />*/}
            Nessun parametro da configurare, clicca su connetti e inserisci le credenziali.
        </div>;
        return modal;
    }
    buildMarketplacePopup(dval, le) {
        let content;
        let connectHandler = (a, b) => { this.detailClick(a, b) };

        switch (this.state.modalTarget.toLowerCase()) {
            case "amazon":
                content = this.buildAmazonGUI(dval, le.amazon);
                break;
            case "woocommerce":
                content = this.buildWooCommerceGUI(dval, le.woocommerce);
                break;
            case "prestashop":
                content = this.buildPrestashopGUI(dval, le.prestashop);
                break;
            case "magento1":
                content = this.buildMagento1GUI(dval, le.magento1);
                break;
            case "magento2":
                content = this.buildMagento2GUI(dval, le.magento2);
                break;
            case "shopify":
                content = this.buildShopifyGUI(dval, le.shopify);
                break;
            case "ebay":
                connectHandler = (a, b) => { this.ebayDetailClick() };
                content = this.buildEbayGUI(dval, le.ebay);
                break;
            default:
                content = [];
        }

        return <UIPopup
            className="marketplaces"
            title={this.state.modalTarget}
            onCancel={(ev) => (this.detailClick(ev, false))}
            buttons={[
                <UIButton text={le.btnHelp} onClick={(ev) => (this.helpClick(ev, this.state.modalTarget))} disabled={!this.helpClick(null, this.state.modalTarget)}/>,
                <UIButton text={le.btnCancel.replace("%marketplace%", this.state.modalTarget)} onClick={(ev) => (this.detailClick(ev, false))} />,
                <UIButton className="confirm" text={le.btnOk.replace("%marketplace%", this.state.modalTarget)} onClick={(ev) => (connectHandler(ev, true))} />
            ]}>
            {content}
        </UIPopup>;
    }




    render() {
        let modal = [];
        let le = this.le;

        if (this.state.modalTarget) {
            const dVal = this.state.details;
            const texts = Object.assign({}, le.details);
            modal = this.buildMarketplacePopup(dVal, texts);
        }

        let x = 1;
        let icons = this.state.marketPlaceListConf.filter(el => el.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) >= 0).map(
            (el, idx) => (<ScrollableGridItem key={(++x)} id={el.id} icon={el.logo} title={el.name} onClick={this.logoClick}/>)
        );

        let rows = Object.entries(this.state.allDetails).map(([key, value], idx) => (
            [<div className="entry-list-row-panel" key={"entrylist-panel-1-" + idx}>
                <div className="entry-list-edit" onClick={(ev) => this.listButtonClick(ev, value.name, 'edit', value.name)} />
                <div className="entry-list-delete" onClick={(ev) => this.listButtonClick(ev, value.name, 'remove', value.name)} />
                <div className="entry-list-icon" style={{ backgroundImage: 'url(' + value.icon + ')' }} />
                <div className="entry-list-text">{value.name}</div>
            </div>,
                <div className="entry-list-row-panel" key={"entrylist-panel-2-" + idx}></div>,
                <div className="entry-list-row-panel" key={"entrylist-panel-3-" + idx}>
                <div className={"entry-list-status " + (value.status ? '' : 'off')} onClick={(ev) => this.listButtonClick(ev, value.name, 'disable', value.name)}></div>
                <div className="entry-list-text">{value.status ? le.list.active : le.list.inactive}</div>
            </div>]
        ));

        let ebayConnector = this.state.ebayConnector ? <EbayConnector
            onDone={(x) => { this.ebayDetailClick(x) }}
            //ebayDto={this.state.details.marketPlacePars}
            ebayDto={this.state.marketPlaceListConf.find(i => i.name.toLowerCase() == 'ebay').marketPlaceSettings}
            forceLogin={true}
            popupErrorMessage={this.props.popupErrorMessage}
        /> : null;


        return <div className="page-marketplaces">
            <PageTitle icon="../images/mainMenu/Marketplaces.png" title={Languages.getSection('Main').menuLabels.marketplaces} />
            <div className="page-content">
                <div className="widget"> 
                    <div className="widget-content">
                        <div className="widget-content-title">{le.marketplaces.title}</div>
                        <div className="widget-content-subtitle">{le.marketplaces.info}</div>
                        <USearch rowClass="widget-content-search " search={le.marketplaces.search} value={this.state.filter} onChange={this.filterChange} />
                        <div className="widget-content-title">{le.marketplaces.allMarketplaces}</div>
                        <ScrollableGrid>
                            {icons}
                        </ScrollableGrid>
                    </div>
                    <div className="widget-footer"/>
                </div>

                <div className="widget">
                    <div className="widget-content for-entry-list">
                        <div className="entry-list" key="entrylist">
                            <div className="entry-list-row-panel entry-list-row-header">
                                <div>{le.list.marketplace}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header"/>
                            <div className="entry-list-row-panel entry-list-row-header">
                                <div className="">{le.list.status}</div>
                            </div>
                            {rows}
                        </div>
                    </div>
                    <div className="widget-footer" />
                </div>
            </div>
            {modal}
            {this.state.messageBox}
            {ebayConnector}
        </div>;
    }
}

